import React, { useState } from 'react';
import {
  FormControl,
  TableContainer,
  Table,
  TableCell,
  TableHead,
  Grid,
  TableRow,
  TableBody,
  TextField,
  Button,
  Typography,
  Modal,
  Box
} from '@mui/material';
import { Edit } from '@mui/icons-material';
import { Colors } from '../utils/Colors';
import { HomeworkTask } from '../utils/Homework';

const formStyle = {
  backgroundColor: Colors.lightGray,
  border: `4px solid ${Colors.skobeloff}`,
  borderRadius: '15px',
  padding: '10px 5px'
};

function EntryTable({
  task,
  onTaskChange,
  onTaskUpdate
}: {
  task: HomeworkTask;
  onTaskChange: (event: any) => void;
  onTaskUpdate: () => void;
}) {
  const [showNotesModal, setShowNotesModal] = useState(false);

  const handleOpenNotesModal = () => setShowNotesModal(true);
  const handleCloseNotesModal = () => setShowNotesModal(false);

  return (
    <Grid item xs={12} md={12} lg={12} xl={6} style={formStyle}>
      <Grid container spacing={2} style={{ padding: '20px' }}>
        <FormControl style={{ width: '100%' }}>
          <TableContainer>
            <Table aria-label="erp trial">
              <TableHead>
                <TableRow>
                  <TableCell>Starting Anxiety</TableCell>
                  <TableCell>Ending Anxiety</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                <TableCell component="th" scope="row">
                  <TextField
                    id="startingAnxiety"
                    value={task.startingAnxiety || ''}
                    size="small"
                    type="tel"
                    onChange={(event) => onTaskChange(event)}
                  />
                </TableCell>
                <TableCell component="th" scope="row">
                  <TextField
                    id="endingAnxiety"
                    value={task.endingAnxiety || ''}
                    size="small"
                    type="tel"
                    onChange={(event) => onTaskChange(event)}
                  />
                </TableCell>
                <TableCell component="th" scope="row">
                  <Button
                    style={{ color: '#010d0d' }}
                    onClick={handleOpenNotesModal}
                  >
                    <Edit />
                  </Button>
                </TableCell>
                <TableCell component="th" scope="row">
                  <Button
                    color="inherit"
                    style={{
                      padding: '5px 20px',
                      color: '#010d0d',
                      borderRadius: 30,
                      fontSize: '20px',
                      backgroundColor: Colors.ocdGreen
                    }}
                    onClick={() => onTaskUpdate()}
                  >
                    <Typography style={{ color: Colors.ocdWhite }}>
                      COMPLETE
                    </Typography>
                  </Button>
                </TableCell>
                <Modal open={showNotesModal} onClose={handleCloseNotesModal}>
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: 400,
                      bgcolor: 'background.paper',
                      p: 4
                    }}
                  >
                    <Typography variant="h6" component="h2">
                      Edit Notes
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      id="notes"
                      value={task.notes || ''}
                      onChange={(event) => onTaskChange(event)}
                      sx={{ mt: 2 }}
                    />
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        mt: 3
                      }}
                    >
                      <Button
                        style={{
                          padding: '5px 20px',
                          color: '#010d0d',
                          borderRadius: 30,
                          fontSize: '20px',
                          backgroundColor: Colors.ocdGreen
                        }}
                        onClick={handleCloseNotesModal}
                        color="inherit"
                        sx={{ mt: 3 }}
                      >
                        Save
                      </Button>
                    </Box>
                  </Box>
                </Modal>
              </TableBody>
            </Table>
          </TableContainer>
        </FormControl>
      </Grid>
    </Grid>
  );
}

export function Task({
  task,
  onTaskChange,
  onTaskUpdate,
  overrideStyles
}: {
  task: HomeworkTask;
  onTaskChange: (event: any) => void;
  onTaskUpdate: () => void;
  overrideStyles?: any;
}) {
  return (
    <Grid container style={overrideStyles}>
      <EntryTable
        onTaskChange={onTaskChange}
        onTaskUpdate={onTaskUpdate}
        task={task}
      />
    </Grid>
  );
}
